import React, { useState, useRef, useEffect } from "react";
import "./OurPartner.css";
import { motion } from "framer-motion";

const partners = [
  {
    id: 1,
    name: "Vedanta",
    image: "images/vedanta.png",
  },
  {
    id: 2,
    name: "IMFG",
    image: "images/imfg.png",
  },
  {
    id: 3,
    name: "Larsen & Toubro",
    image: "images/lnt.png",
  },
  {
    id: 4,
    name: "Odisha TV",
    image: "images/Otv.png",
  },
  {
    id: 5,
    name: "RKD Construction",
    image: "images/rkd.png",
  },
  // {
  //   id: 6,
  //   name: "St. Xavier's High School",
  //   image: "/images/partners/st-xaviers.png",
  // },
  {
    id: 7,
    name: "Lloyds Metals",
    image: "images/llmetals.png",
  },
  {
    id: 8,
    name: "Thriveni",
    image: "images/triveni.png",
  },

  {
    id: 10,
    name: "rkd",
    image: "images/rkd.png",
  },
  {
    id: 11,
    name: "Ruchi",
    image: "images/ruchi.png",
  },
  {
    id: 12,
    name: "Sudha",
    image: "images/sudha.png",
  },
];

const OurPartner = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [autoplay, setAutoplay] = useState(true);
  const autoplayRef = useRef();

  useEffect(() => {
    if (autoplay) {
      autoplayRef.current = setInterval(() => {
        nextSlide();
      }, 3000);
    }
    return () => {
      if (autoplayRef.current) {
        clearInterval(autoplayRef.current);
      }
    };
  }, [autoplay, currentSlide]);

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev === partners.length - 4 ? 0 : prev + 1));
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev === 0 ? partners.length - 4 : prev - 1));
  };

  const goToSlide = (index) => {
    setCurrentSlide(index);
  };

  return (
    <div className="partners-page">
      <motion.section
        className="partners-hero-section"
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        transition={{ duration: 0.8 }}
      >
        <div className="hero-content">
          <motion.h1
            initial={{ y: 20, opacity: 0 }}
            whileInView={{ y: 0, opacity: 1 }}
            transition={{ duration: 0.5 }}
          >
            Powering Smarter Fleets with Trusted Partnerships
          </motion.h1>
          <motion.p
            initial={{ y: 20, opacity: 0 }}
            whileInView={{ y: 0, opacity: 1 }}
            transition={{ duration: 0.5, delay: 0.2 }}
          >
            We collaborate with industry leaders to deliver advanced fleet management hardware 
            and software, providing a seamless, one-stop solution for efficient and compliant 
            fleet operations.
          </motion.p>
        </div>
      </motion.section>

      {/* Government Certification Section */}
      <motion.section
        className="certification-section"
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        transition={{ duration: 0.8 }}
      >
        <div className="certification-content">
          <motion.h2
            initial={{ y: 20, opacity: 0 }}
            whileInView={{ y: 0, opacity: 1 }}
            transition={{ duration: 0.5 }}
          >
            Government Certified GPS Devices for Compliance & Performance
          </motion.h2>
          <motion.p
            initial={{ y: 20, opacity: 0 }}
            whileInView={{ y: 0, opacity: 1 }}
            transition={{ duration: 0.5, delay: 0.2 }}
          >
            We provide AIS140- Govt. certified GPS tracking solutions that meet government 
            regulations, ensuring seamless compliance and enhanced fleet efficiency.
          </motion.p>

          <div className="compliance-features">
            {[
              "Compliance with AIS140 Regulations",
              "Real-time GPS Tracking & Monitoring",
              "Emergency SOS Alerts & Safety Features",
              "Integrated with Government Servers",
              "Secure Data Transmission & Remote Updates",
              "Ideal for Passenger Transport, Logistics, and Mining Fleets"
            ].map((feature, index) => (
              <motion.div
                key={feature}
                className="feature-item"
                initial={{ opacity: 0, x: -20 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
              >
                <div className="feature-icon">✅</div>
                <p>{feature}</p>
              </motion.div>
            ))}
          </div>
        </div>
      </motion.section>

      <motion.section
        className="esteemed-clients-section"
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        transition={{ duration: 0.8 }}
      >
        <div className="section-header">
          <motion.h2
            initial={{ y: 20, opacity: 0 }}
            whileInView={{ y: 0, opacity: 1 }}
            transition={{ duration: 0.5 }}
          >
            Our Trusted Clients
          </motion.h2>
        </div>

        <div className="partners-slider-container">
          <button className="slider-button prev" onClick={prevSlide}>
            &#8249;
          </button>

          <div className="partners-slider">
            {partners.slice(currentSlide, currentSlide + 4).map((partner) => (
              <motion.div
                key={partner.id}
                className="partner-logo-container"
                initial={{ opacity: 0, scale: 0.8 }}
                animate={{ opacity: 1, scale: 1 }}
                transition={{ duration: 0.5 }}
                whileHover={{ 
                  scale: 1.05,
                  boxShadow: '0 4px 20px rgba(0, 0, 0, 0.1)'
                }}
              >
                <img
                  src={partner.image}
                  alt={partner.name}
                  className="partner-logo"
                />
              </motion.div>
            ))}
          </div>

          <button className="slider-button next" onClick={nextSlide}>
            &#8250;
          </button>

          <div className="carousel-dots">
            {partners.map((_, index) => (
              <div
                key={index}
                className={`dot ${currentSlide === index ? "active" : ""}`}
                onClick={() => goToSlide(index)}
              />
            ))}
          </div>
        </div>
      </motion.section>
    </div>
  );
};

export default OurPartner;
